import { FC } from 'react';
import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { Entity, stringifyEntityRef } from '@mainstage/catalog-model';
import { JsonObject } from '@mainstage/types';
import { useDeleteServiceAccount } from '@agilelab/backstage-plugin-wb-service-accounts';

type DeleteServiceAccountDialogProps = {
  serviceAccountToDelete: Entity | null;
  onClose: () => void;
  onDeleted?: () => void;
};

export const DeleteServiceAccountDialog: FC<
  DeleteServiceAccountDialogProps
> = ({ serviceAccountToDelete, onClose, onDeleted }) => {
  const { isLoading: deleting, mutate: deleteFn } = useDeleteServiceAccount();

  const name =
    (serviceAccountToDelete?.spec?.profile as JsonObject)?.displayName ??
    serviceAccountToDelete?.metadata?.name ??
    '';

  return (
    <ConfirmDialog
      inProgress={deleting}
      open={Boolean(serviceAccountToDelete)}
      onClick={e => e.stopPropagation()}
      onClose={onClose}
      title={`Are you sure you want to delete ${name}?`}
      description="Deleting this service account will also delete and invalidate its linked access token. This action cannot be undone."
      onConfirm={() => {
        if (!serviceAccountToDelete) return;
        const userRef = stringifyEntityRef(serviceAccountToDelete);
        deleteFn(
          { userRefs: userRef },
          {
            onSuccess: () => {
              onDeleted?.();
              onClose();
            },
            onError: () => {
              onClose();
            },
          },
        );
      }}
    />
  );
};
